import { render, staticRenderFns } from "./TransactionSuccessMessageView.vue?vue&type=template&id=a5bbd264&"
import script from "./TransactionSuccessMessageView.vue?vue&type=script&lang=js&"
export * from "./TransactionSuccessMessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports